export default __webpack_public_path__ + "static/media/Done.ace90fd0.svg";